var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status === 'unassigned')?_c('el-tag',{attrs:{"type":_vm.setType('unassigned')}},[_vm._v("Unassigned ")]):_vm._l((_vm.personnel),function(person,index){return _c('span',{key:index,staticClass:"personnel"},[_vm._v(_vm._s(person))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }